import {
  styled, rem
} from 'config/stitches.config'


export const StyledSearch  = styled('div', {
  width: '100%',
  maxHeight: '100vh',
  overflowY: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
  scrollBehavior: 'smooth',
  overscrollBehavior: 'contain',
  scrollbarWidth: 'none',
  position: 'relative'
})

export const StyledSearchHeader = styled('div', {
  position: 'sticky',
  left: 0,
  top: 0,
  display: 'flex',
  backgroundColor: '$primary',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 128,
  width: '100%',
  columnGap: 32,

  '.SearchForm': {
    width: '100%',

    'fieldset': { margin: 0 },

    'input:not([type="checkbox"]):not([type="radio"])': {
      fontSize: '$subtitle-2-mobile',
      lineHeight: '$subtitle-2-mobile',
      backgroundColor: 'transparent',
      borderBottom: 'none',
      color: '$white',
      textIndent: rem(16),

      '&::-webkit-search-cancel-button': {
        appearance: 'none',
        size: '$1',
        br: '$round',
        border: '1px solid $white',
        marginRight: '$3',
      },

      '&::placeholder': {
        color: '$gray !important',
        opacity: 1
      },

      '@md': {
        textIndent: rem(12),
        fontSize: '$subtitle-2',
        lineHeight: '$subtitle-2',
      }
    }
  },
})

export const StyledSearchClose = styled('button', {
  $$scale: '0.1',
  position: 'relative',
  padding: 0,
  margin: 0,
  backgroundColor: 'transparent',
  border: 'none',
  flexGrow: 0,
  flexShrink: 0,
  size: rem(24),

  '&::before, &::after': {
    content: '',
    width: rem(24),
    height: 1,
    backgroundColor: '$white',
    position: 'absolute',
    top: '50%',
    left: '50%',
    br: 10,
  },
  '&::before': { transform: 'translate(-50%, -50%) rotate(45deg)' },
  '&::after': { transform: 'translate(-50%, -50%) rotate(-45deg)' },
})


export const StyledSearchResults = styled('div', {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
})
export const StyledSearchResultsList = styled('div', {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  rowGap: rem(64),
  paddingBottom: rem(64),
  overflowY: 'scroll'
})

export const StyledCluster = styled('div', {
  color: '$white',
  'strong': { textTransform: 'uppercase' },
  'a': {
    display: 'table',
    color: '$gray',
    textDecoration: 'none',
  }
})


export const StyledClusterItem = styled('div', {
  paddingY: '$3',
  borderBottom: '1px solid $gray',
  display: 'block'
})


export const StyledSearchNoResult = styled('div', {
  color: '$white',
  '.NoResultMessage': {
    display: 'block',
    marginBottom: rem(72)
  }
})
